import React from "react";
import styles from "./BetTablePoker.module.css";


export default function BetTablePoker({ data = [], onBetClick, exposures = {}, myBets = [] }) {
  // Data structure: sub[0] = Player A match, sub[1] = Player B match
  // sub[2] = Player A 2 card, sub[3] = Player A 7 card
  // sub[4] = Player B 2 card, sub[5] = Player B 7 card
  const playerAMatch = data[0] || {};
  const playerBMatch = data[1] || {};
  const playerA2Card = data[2] || {};
  const playerA7Card = data[3] || {};
  const playerB2Card = data[4] || {};
  const playerB7Card = data[5] || {};

  // Get first bet data for min/max
  const firstBet = playerAMatch || playerBMatch || {};

  const formatLimit = (value) => {
    if (value >= 1000) {
      return `${(value / 1000).toFixed(0)}K`;
    }
    return value?.toFixed(1) || "100.0";
  };

  // Format exposure value
  const formatExposure = (value) => {
    if (value === null || value === undefined || value === 0) return "0";
    if (Math.abs(value) >= 1000) {
      return value < 0 ? value.toFixed(0) : value.toFixed(0);
    }
    return value < 0 ? value.toFixed(2) : value.toFixed(2);
  };

  // Get exposure for a selection
  const getExposure = (selection, betType = null) => {
    const keys = [
      betType ? `${selection} ${betType}` : null,
      selection,
      betType ? `${selection} ${betType}` : null,
    ].filter(Boolean);

    for (const key of keys) {
      if (exposures[key] !== undefined) {
        return exposures[key];
      }
    }
    return 0;
  };

  // Check if bet is suspended
  const isSuspended = (betData) => {
    return betData?.gstatus?.toUpperCase() === "SUSPENDED" || !betData || betData.b === 0 || betData.b === null || betData.b === undefined || betData.b === "0";
  };

  // Format bet value (show b/l for odds)
  const formatBetValue = (betData, type = "back") => {
    if (type === "back") {
      return betData?.b || "0";
    }
    return betData?.l || "0";
  };

  // Format available amount (show bs/ls)
  const formatAvailableAmount = (betData, type = "back") => {
    if (type === "back") {
      return betData?.bs || "0";
    }
    return betData?.ls || "0";
  };

  // Only show header if data exists
  const shouldShowHeader = data && Array.isArray(data) && data.length > 0;

  return (
    <div style={{display: 'flex',alignItems: 'center', gap: '10px'}}>
      {/* Main Match Table */}
      <div className={`table-responsive ${styles.betTablePokerWrapper}`} style={{ width: '50%' }}>
        <table className={`table table-bordered ${styles.betTablePoker}`}>
       
            <thead>
              <tr>
                <th style={{ backgroundColor: '#333d79ff', background: '#333d79ff', color: 'white' }} className="box-4 min-max">
                  <div className="d-block">
                    {/* <div style={{ fontSize: '10px', display: 'flex', color: 'white' }}> Min: <div style={{ fontSize: '10px', color: 'white' }}>{formatLimit(firstBet?.min || 100)}</div></div> */}
                    {/* <div style={{ fontSize: '10px', display: 'flex', color: 'white' }}> Max: <div style={{ fontSize: '10px', color: 'white' }}>{formatLimit(firstBet?.max || 300000)}</div></div> */}
                  </div>
                </th>
                <th style={{ backgroundColor: '#72bbef', background: '#72bbef', fontSize: '12px' }} className="text-center box-3 Back">BACK</th>
                <th style={{ backgroundColor: '#faa9ba', background: '#faa9ba', fontSize: '12px' }} className="text-center box-3 lay">LAY</th>
              </tr>
            </thead>
          
          <tbody>
            {/* Player A Row */}
            <tr key="playerA" data-title={playerAMatch?.gstatus || "OPEN"} className={isSuspended(playerAMatch) ? styles.suspendedRow : ""}>
              <td className="box-4 player-name" style={{ backgroundColor: '#333d79ff', background: '#333d79ff', color: 'white' }}>
                <div style={{ color: 'white', fontSize: '12px', marginLeft: '10px' }}>{playerAMatch?.nat || "Player A"}</div>
                <span className="d-block" style={{ color: 'white', fontSize: '12px ', marginLeft: '10px' }}>
                  {formatExposure(getExposure(playerAMatch?.nat || "Player A"))}
                </span>
              </td>

              {/* Player A Back */}
              <td
                className={`back text-center box-3 back ${isSuspended(playerAMatch) ? styles.suspended : ''}`}
                onClick={() => !isSuspended(playerAMatch) && onBetClick && onBetClick(formatBetValue(playerAMatch, "back"), playerAMatch?.nat || "Player A", "back", playerAMatch)}
                style={{
                  cursor: isSuspended(playerAMatch) ? 'not-allowed' : 'pointer',
                  backgroundColor: '#72bbef',
                  background: '#72bbef',
                  position: 'relative'
                }}
              >
                <div className="position-relative d-flex flex-column align-items-center justify-content-center h-100" style={{ minHeight: '40px' }}>
                  <span className="d-block text-bold odds">{formatBetValue(playerAMatch, "back")}</span>
                  <span className="d-block" style={{ fontSize: '10px', color: 'black' }}>{formatAvailableAmount(playerAMatch, "back")}</span>
                </div>
              </td>

              {/* Player A Lay */}
              <td
                className={`back text-center box-3 lay ${isSuspended(playerAMatch) ? styles.suspended : ''}`}
                onClick={() => !isSuspended(playerAMatch) && onBetClick && onBetClick(formatBetValue(playerAMatch, "lay"), playerAMatch?.nat || "Player A", "lay", playerAMatch)}
                style={{
                  cursor: isSuspended(playerAMatch) ? 'not-allowed' : 'pointer',
                  backgroundColor: '#faa9ba',
                  background: '#faa9ba',
                  position: 'relative'
                }}
              >
                <div className="position-relative d-flex flex-column align-items-center justify-content-center h-100" style={{ minHeight: '40px' }}>
                  <span className="d-block text-bold odds">{formatBetValue(playerAMatch, "lay")}</span>
                  <span className="d-block" style={{ fontSize: '10px', color: 'black' }}>{formatAvailableAmount(playerAMatch, "lay")}</span>
                </div>
              </td>
            </tr>

            {/* Player B Row */}
            <tr key="playerB" data-title={playerBMatch?.gstatus || "OPEN"} className={isSuspended(playerBMatch) ? styles.suspendedRow : ""}>
              <td className="box-4 player-name" style={{ backgroundColor: '#333d79ff', background: '#333d79ff', color: 'white' }}>
                <div style={{ color: 'white', fontSize: '12px', marginLeft: '10px' }}>{playerBMatch?.nat || "Player B"}</div>
                <span className="d-block" style={{ color: 'white', fontSize: '12px ', marginLeft: '10px' }}>
                  {formatExposure(getExposure(playerBMatch?.nat || "Player B"))}
                </span>
              </td>

              {/* Player B Back */}
              <td
                className={`back text-center box-3 back ${isSuspended(playerBMatch) ? styles.suspended : ''}`}
                onClick={() => !isSuspended(playerBMatch) && onBetClick && onBetClick(formatBetValue(playerBMatch, "back"), playerBMatch?.nat || "Player B", "back", playerBMatch)}
                style={{
                  cursor: isSuspended(playerBMatch) ? 'not-allowed' : 'pointer',
                  backgroundColor: '#72bbef',
                  background: '#72bbef',
                  position: 'relative'
                }}
              >
                <div className="position-relative d-flex flex-column align-items-center justify-content-center h-100" style={{ minHeight: '40px' }}>
                  <span className="d-block text-bold odds">{formatBetValue(playerBMatch, "back")}</span>
                  <span className="d-block" style={{ fontSize: '10px', color: 'black' }}>{formatAvailableAmount(playerBMatch, "back")}</span>
                </div>
              </td>

              {/* Player B Lay */}
              <td
                className={`back text-center box-3 lay ${isSuspended(playerBMatch) ? styles.suspended : ''}`}
                onClick={() => !isSuspended(playerBMatch) && onBetClick && onBetClick(formatBetValue(playerBMatch, "lay"), playerBMatch?.nat || "Player B", "lay", playerBMatch)}
                style={{
                  cursor: isSuspended(playerBMatch) ? 'not-allowed' : 'pointer',
                  backgroundColor: '#faa9ba',
                  background: '#faa9ba',
                  position: 'relative'
                }}
              >
                <div className="position-relative d-flex flex-column align-items-center justify-content-center h-100" style={{ minHeight: '40px' }}>
                  <span className="d-block text-bold odds">{formatBetValue(playerBMatch, "lay")}</span>
                  <span className="d-block" style={{ fontSize: '10px', color: 'black' }}>{formatAvailableAmount(playerBMatch, "lay")}</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Bonus Bet Section */}
      <div className={styles.bonusBetSection} style={{ width: '50%' }}>
      
        <div className={`table-responsive ${styles.betTablePokerWrapper}`}>
          <table className={`table table-bordered m-b-0 ${styles.betTablePoker}`}>
            <thead>
              <tr>
              <td className="box-4 player-name" style={{ backgroundColor: '#333d79ff', background: '#333d79ff', color: 'white' }}></td>
                <th style={{ backgroundColor: '#72bbef', background: '#72bbef', fontSize: '12px' }} className="text-center box-3 Back">BACK</th>
                <th style={{ backgroundColor: '#72bbef', background: '#72bbef', fontSize: '12px' }} className="text-center box-3 back">BACK</th>
              </tr>
            </thead>
            <tbody>
              {/* Player A Bonus Row */}
              <tr key="playerABonus" data-title={playerA2Card?.gstatus || "OPEN"} className={isSuspended(playerA2Card) && isSuspended(playerA7Card) ? styles.suspendedRow : ""}>
                <td className="box-4 player-name" style={{ backgroundColor: '#333d79ff', background: '#333d79ff', color: 'white' }}>
                  <div style={{ color: 'white', fontSize: '12px', marginLeft: '10px' }}>{playerA2Card?.nat?.replace(" 2 card Bonus", "") || playerA7Card?.nat?.replace(" 7 card bonus", "") || "Player A"}</div>
                </td>

                {/* Player A 2 Card Bonus */}
                <td
                  className={`back text-center box-3 back ${isSuspended(playerA2Card) ? styles.suspended : ''}`}
                  onClick={() => !isSuspended(playerA2Card) && onBetClick && onBetClick(playerA2Card?.b || "0", playerA2Card?.nat || "Player A 2 card Bonus", "back", playerA2Card)}
                  style={{
                    cursor: isSuspended(playerA2Card) ? 'not-allowed' : 'pointer',
                    backgroundColor: '#72bbef',
                    background: '#72bbef',
                    position: 'relative'
                  }}
                >
                  <div className="position-relative d-flex flex-column align-items-center justify-content-center h-100" style={{ minHeight: '40px' }}>
                    <div className="d-block text-bold odds" style={{ fontSize: '12px' , fontWeight: 'bold'}}>{playerA2Card?.nat || "Player A 2 card Bonus"}</div>
                    <div className="d-block" style={{ color: 'black', fontSize: '10px' , fontWeight: 'normal'}}>{formatExposure(getExposure(playerA2Card?.nat || "Player A 2 card Bonus", "back"))}</div>
                  </div>
                </td>

                {/* Player A 7 Card Bonus */}
                <td
                  className={`back text-center box-3 back ${isSuspended(playerA7Card) ? styles.suspended : ''}`}
                  onClick={() => !isSuspended(playerA7Card) && onBetClick && onBetClick(playerA7Card?.b || "0", playerA7Card?.nat || "Player A 7 card bonus", "back", playerA7Card)}
                  style={{
                    cursor: isSuspended(playerA7Card) ? 'not-allowed' : 'pointer',
                    backgroundColor: '#72bbef',
                    background: '#72bbef',
                    position: 'relative'
                  }}
                >
                  <div className="position-relative d-flex flex-column align-items-center justify-content-center h-100" style={{ minHeight: '40px' }}>
                    <div className="d-block text-bold odds" style={{ fontSize: '12px' , fontWeight: 'bold'}}>{playerA7Card?.nat || "Player A 7 card bonus"}</div>
                    <div className="d-block" style={{ color: 'black', fontSize: '10px' , fontWeight: 'normal'}}>{formatExposure(getExposure(playerA7Card?.nat || "Player A 7 card bonus", "back"))}</div>
                  </div>
                </td>
              </tr>

              {/* Player B Bonus Row */}
              <tr key="playerBBonus" data-title={playerB2Card?.gstatus || "OPEN"} className={isSuspended(playerB2Card) && isSuspended(playerB7Card) ? styles.suspendedRow : ""}>
                <td className="box-4 player-name" style={{ backgroundColor: '#333d79ff', background: '#333d79ff', color: 'white' }}>
                  <div style={{ color: 'white', fontSize: '12px', marginLeft: '10px' }}>{playerB2Card?.nat?.replace(" 2 card Bonus", "") || playerB7Card?.nat?.replace(" 7 card bonus", "") || "Player B"}</div>
                </td>

                {/* Player B 2 Card Bonus */}
                <td
                  className={`back text-center box-3 back ${isSuspended(playerB2Card) ? styles.suspended : ''}`}
                  onClick={() => !isSuspended(playerB2Card) && onBetClick && onBetClick(playerB2Card?.b || "0", playerB2Card?.nat || "Player B 2 card Bonus", "back", playerB2Card)}
                  style={{
                    cursor: isSuspended(playerB2Card) ? 'not-allowed' : 'pointer',
                    backgroundColor: '#72bbef',
                    background: '#72bbef',
                    position: 'relative'
                  }}
                >
                  <div className="position-relative d-flex flex-column align-items-center justify-content-center h-100" style={{ minHeight: '40px' }}>
                    <div className="d-block text-bold odds" style={{ fontSize: '12px' , fontWeight: 'bold'}}>{playerB2Card?.nat || "Player B 2 card Bonus"}</div>
                    <div className="d-block" style={{ color: 'black', fontSize: '10px' , fontWeight: 'normal'}}>{formatExposure(getExposure(playerB2Card?.nat || "Player B 2 card Bonus", "back"))}</div>
                  </div>
                </td>

                {/* Player B 7 Card Bonus */}
                <td
                  className={`back text-center box-3 back ${isSuspended(playerB7Card) ? styles.suspended : ''}`}
                  onClick={() => !isSuspended(playerB7Card) && onBetClick && onBetClick(playerB7Card?.b || "0", playerB7Card?.nat || "Player B 7 card bonus", "back", playerB7Card)}
                  style={{
                    cursor: isSuspended(playerB7Card) ? 'not-allowed' : 'pointer',
                    backgroundColor: '#72bbef',
                    background: '#72bbef',
                    position: 'relative'
                  }}
                >
                  <div className="position-relative d-flex flex-column align-items-center justify-content-center h-100" style={{ minHeight: '40px' }}>
                    <div className="d-block text-bold odds" style={{ fontSize: '12px' , fontWeight: 'bold'}}>{playerB7Card?.nat || "Player B 7 card bonus"}</div>
                    <div className="d-block" style={{ color: 'black', fontSize: '10px' , fontWeight: 'normal'}}>{formatExposure(getExposure(playerB7Card?.nat || "Player B 7 card bonus", "back"))}</div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

